import { View, Button } from "@/components/ui";
import { Typography } from "../../typography";
import { BottomDrawerModal } from "../../bottom-drawer-modal";
import { LuceSparkle } from "@/components/shared/icons";
import { useBookingRoute } from "@/components/hooks/use-booking-route";

export const AirconDisclaimerModal = ({
  isOpen,
  onAcknowledge,
}: {
  isOpen: boolean;
  onAcknowledge: () => void;
}) => {
  const { forward } = useBookingRoute();
  const handleClick = () => {
    onAcknowledge();
    forward();
  };

  return (
    <BottomDrawerModal open={isOpen} onOpenChange={onAcknowledge}>
      <View className="flex flex-1 flex-col px-2">
        <Typography variant="label-md">Aircon Servicing Disclaimer</Typography>
        <Description label="By proceeding with this booking, you acknowledge and agree to the following:" />
        <AirconDisclaimerSection
          title="Condominium Notice"
          content={
            'If your service is in a condominium, please inform your MCST in advance if your appointment falls within any "no work" periods, especially for condenser wash services. Failure to obtain prior approval may result in rescheduling upon arrival.'
          }
        />
        <AirconDisclaimerSection
          title="Height & Safety Requirement"
          content="For safety reasons, our technicians can only service indoor aircon units that are 3 meters or lower from the ground. If your unit exceeds this height, please contact our sales team to arrange additional assistance."
        />
        <AirconDisclaimerSection
          title="Package Validity Reminder"
          content="For yearly recurring packages, unused service credits will expire one year from the date of your first visit, in accordance with our Terms & Conditions, unused credits are non-refundable."
        />
        <Description label='By clicking "Acknowledge", you confirm that you have read, understood, and agreed to the above disclaimer.' />
      </View>
      <View className="flex flex-col px-2 pt-4">
        <Button
          children="Acknowledge"
          variant="primary"
          color="CTA"
          onClick={handleClick}
        />
      </View>
    </BottomDrawerModal>
  );
};

const AirconDisclaimerSection = ({
  title,
  content,
}: {
  title: string;
  content: string;
}) => {
  return (
    <View className="flex flex-1 flex-row items-center gap-4 border-b border-secondary-border py-3 md:py-4">
      <LuceSparkle className="size-6 max-w-[24px] shrink-0 text-brand-primary" />
      <View className="flex flex-1 flex-col">
        <Typography variant="label-sm">{title}</Typography>
        <Typography variant="body-sm" className="mt-1">
          {content}
        </Typography>
      </View>
    </View>
  );
};

const Description = ({ label }: { label: string }) => {
  return (
    <View className="flex flex-row items-center gap-4 border-b border-secondary-border py-3 md:py-4">
      <Typography variant="body-md">{label}</Typography>
    </View>
  );
};
